<template>
  <div class="app-container">
    <NavTitle :title="title" />
    <div class="top-box">
      <div class="map-box" v-loading="loading">
        <div ref="mapRef" class="map" />
        <img
          class="refresh-img"
          src="@/assets/location/refresh.png"
          @click="handleRefresh"
        />
      </div>
      <div class="search-box">
        <div class="search-item-box">
          <div class="search-item">
            <div class="search-item-label">考勤日期</div>
            <div class="search-item-input">
              <el-date-picker
                v-model="queryParam.date"
                type="date"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                :clearable="false"
                :editable="false"
                size="mini"
              />
            </div>
          </div>
          <div class="search-item">
            <div class="search-item-label">考勤类型</div>
            <div class="search-item-input">
              <el-select
                v-model="queryParam.type"
                placeholder="请选择"
                clearable
                size="mini"
                style="width: 100%"
              >
                <el-option
                  v-for="item in filterData.types"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="search-item">
            <div class="search-item-label">门店名称</div>
            <div class="search-item-input">
              <el-input
                v-model="queryParam.storeName"
                placeholder="请输入"
                size="mini"
                @keyup.enter.native="handleSearch"
              />
            </div>
          </div>
          <div class="search-item">
            <div class="search-item-label">人员姓名</div>
            <div class="search-item-input">
              <el-input
                v-model="queryParam.realName"
                placeholder="请输入"
                size="mini"
                @keyup.enter.native="handleSearch"
              />
            </div>
          </div>
          <div class="search-item">
            <div class="search-item-label">人员岗位</div>
            <div class="search-item-input">
              <el-select
                v-model="queryParam.stations"
                multiple
                size="mini"
                collapse-tags
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in filterData.stations"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="search-item">
            <div class="search-item-label">考勤距离</div>
            <div class="search-item-input">
              <el-select
                v-model="queryParam.distance"
                placeholder="请选择"
                clearable
                style="width: 100%"
                size="mini"
              >
                <el-option
                  v-for="item in filterData.distance"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="search-item">
            <div class="search-item-label">考勤状态</div>
            <div class="search-item-input">
              <el-select
                v-model="queryParam.state"
                placeholder="请选择"
                clearable
                size="mini"
                style="width: 100%"
              >
                <el-option
                  v-for="item in filterData.states"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
        </div>
        <div class="search-button">
          <el-button type="primary" size="mini" @click="handleSearch"
            >查询</el-button
          >
          <el-button plain size="mini" @click="handleReset">重置</el-button>
        </div>
      </div>
    </div>
    <div class="table-box">
      <div class="table-button">
        <el-button
          type="primary"
          size="mini"
          @click="handleExport"
          :loading="buttonLoading"
        >
          <i class="el-icon-download"></i>
          导出
        </el-button>
      </div>
      <div class="table-d">
        <el-table
          ref="workTableRef"
          :data="tableList"
          stripe
          :header-cell-style="{
            background: '#F0F3F7',
            color: '#2a354e',
            fontWeight: 400,
          }"
          height="350"
          highlight-current-row
          :row-key="'id'"
          @row-click="handleRowClick"
          @sort-change="handleSortChange"
          v-loading="loading"
          size="mini"
        >
          <el-table-column label="操作" width="60">
            <template slot-scope="scope">
              <img
                style="width: 16px; height: 16px; cursor: pointer"
                src="@/assets/location/address-table.png"
                alt=""
                @click="handleTableCode(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="signedType"
            label="考勤类型"
            width="100"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="color: #6bc440" v-if="scope.row.signedType === 0"
                >到岗</span
              >
              <span style="color: #4076f2" v-if="scope.row.signedType === 1"
                >离岗</span
              >
              <span style="color: #ff3a3a" v-if="scope.row.isRepaired"
                >补签</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="signedDateStr"
            label="日期"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="signedTimeStr"
            label="考勤时间"
            width="150"
            :show-overflow-tooltip="true"
            sortable="custom"
          />
          <el-table-column
            prop="userName"
            label="人员姓名"
            width="150"
            :show-overflow-tooltip="true"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span>
                {{ scope.row.userName }}
              </span>
              <span v-if="scope.row.isEnterpriseAdmin">(管理员)</span>
              <span
                class="table-state red isClick"
                v-if="scope.row.userInvalid"
                @click="
                  handleClickTag(
                    scope.row.userInvalidTitle,
                    scope.row.userInvalidContent
                  )
                "
                >账号失效
                <i class="el-icon-caret-right" />
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="userStations" label="岗位" width="200">
            <template slot-scope="scope">
              <span
                v-for="(v, i) in scope.row.stations"
                :key="i"
                class="table-tag"
              >
                {{ v }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="onlineTime"
            label="在岗时长"
            :show-overflow-tooltip="true"
            width="150"
            sortable="custom"
          />
          <el-table-column prop="enterpriseName" label="门店名称" width="250" />
          <el-table-column
            prop="gapStr"
            label="考勤距离"
            :show-overflow-tooltip="true"
            width="150"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span style="margin-right: 10px">{{ scope.row.gapStr }}</span>
              <div
                :class="[
                  'table-state',
                  {
                    yellow: scope.row.distanceStates.stateStr === '较远',
                    red:
                      scope.row.distanceStates.stateStr === '超出' ||
                      scope.row.distanceStates.stateStr === '无效' ||
                      scope.row.distanceStates.stateStr === '异常',
                    isClick: scope.row.distanceStates.title,
                  },
                ]"
                @click="
                  handleClickTag(
                    scope.row.distanceStates.title,
                    scope.row.distanceStates.content
                  )
                "
              >
                <span>{{ scope.row.distanceStates.stateStr }}</span>
                <i
                  class="el-icon-caret-right"
                  v-if="scope.row.distanceStates.title"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="states"
            label="考勤状态"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div
                :class="[
                  'table-state',
                  {
                    yellow: scope.row.states.stateStr === '较远',
                    red:
                      scope.row.states.stateStr === '超出' ||
                      scope.row.states.stateStr === '无效' ||
                      scope.row.states.stateStr === '异常',
                    isClick: scope.row.states.title,
                  },
                ]"
                @click="
                  handleClickTag(
                    scope.row.states.title,
                    scope.row.states.content
                  )
                "
              >
                <span>{{ scope.row.states.stateStr }}</span>
                <i class="el-icon-caret-right" v-if="scope.row.states.title" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="mobileBrand"
            label="设备品牌"
            :show-overflow-tooltip="true"
            width="150"
          />
          <el-table-column
            prop="mobileModel"
            label="设备型号"
            :show-overflow-tooltip="true"
            width="150"
          />
          <el-table-column
            prop="mobileSystem"
            label="操作系统"
            :show-overflow-tooltip="true"
            width="150"
          />
          <el-table-column
            prop="mobileVersion"
            label="微信版本"
            :show-overflow-tooltip="true"
            width="150"
          />
          <el-table-column
            prop="signalStrength"
            label="信号强度"
            :show-overflow-tooltip="true"
            width="150"
          />
          <el-table-column
            prop="accuracy"
            label="精准度"
            :show-overflow-tooltip="true"
            width="150"
          />
          <el-table-column
            prop="provider"
            label="定位方式"
            :show-overflow-tooltip="true"
            width="150"
          />
        </el-table>
      </div>
      <div class="table-page">
        <div class="table-page-index">当前 {{ paging.index }} 页</div>
        <el-pagination
          :current-page="paging.index"
          :page-size="paging.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
          background
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <TipDialog ref="TipDialogRef" />
  </div>
</template>

<script>
import { computedLastData } from "@/utils/tool";
import TipDialog from "@/components/TipDialog/index.vue";
import NavTitle from "@/components/NavTitle/index.vue";

export default {
  name: "ChainStoreAttendance",
  components: {
    TipDialog,
    NavTitle,
  },
  data() {
    return {
      title: ["门店考勤"],
      map: null,
      icon: null,
      mapData: [],
      searchName: "",
      queryParam: {
        date: "",
        type: "",
        realName: "",
        stations: [],
        state: "",
        storeName: "",
        distance: "",
        orders: {
          signedTime: null,
          userName: null,
          onlineTime: null,
          gap: null,
        },
      },
      filterData: {},
      tableList: [],
      selectedRow: null,
      total: 0,
      paging: {
        index: 1,
        size: 100,
      },
      loading: false,
      buttonLoading: false,
    };
  },
  mounted() {
    this.fetchData();
    this.initMap();
  },
  methods: {
    handleRefresh() {
      this.initMap();
    },
    handleRowClick(row) {
      this.selectedRow = row;
    },
    handleTableCode(row) {
      this.map.clearMap();

      const markers = [];

      row.map.forEach((item) => {
        const lng = parseFloat(item.preciseLng);
        const lat = parseFloat(item.preciseLat);
        if (isNaN(lng) || isNaN(lat) || lng <= 0 || lat <= 0) return;

        const marker = new AMap.Marker({
          position: [lng, lat],
          icon: this.initIcon(item),
          title: item.address || "",
          offset: new AMap.Pixel(-20, -50),
        });

        marker.on("click", () => {
          this.focusMarker(marker, item);
        });

        markers.push(marker);
        this.map.add(marker);
      });
      if (markers.length > 0) {
        this.map.setFitView(markers);
      }
      setTimeout(() => {
        const position = markers[0].getPosition();
        this.showInfoWindow(position, row.map[0]);
        if (markers.length > 0) {
          this.map.setFitView(markers);
          let minLng = markers[0].getPosition().getLng();
          let maxLng = markers[0].getPosition().getLng();
          let minLat = markers[0].getPosition().getLat();
          let maxLat = markers[0].getPosition().getLat();
          markers.forEach((m) => {
            const pos = m.getPosition();
            minLng = Math.min(minLng, pos.getLng());
            maxLng = Math.max(maxLng, pos.getLng());
            minLat = Math.min(minLat, pos.getLat());
            maxLat = Math.max(maxLat, pos.getLat());
          });
          const lng = (minLng + maxLng) / 2;
          const lat = (minLat + maxLat) / 2 + 0.0004;
          this.map.setCenter([lng, lat], false);
        }
      }, 50);
    },
    async handleExport() {
      this.$confirm("是否确认导出当前列表?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.buttonLoading = true;
        let res = await this.$api.exportCenter.ExportMyStoreCheckWorkList({
          ...this.queryParam,
        });
        this.buttonLoading = false;
        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.href = url;
        link.download = `考勤记录列表_${new Date()
          .toISOString()
          .slice(0, 10)}.xls`;
        link.click();
        window.URL.revokeObjectURL(url);
        this.$notify({
          title: "导出成功!",
          type: "success",
          message: "选中内容导出成功。",
          dangerouslyUseHTMLString: true,
          position: "bottom-right",
          duration: 4000,
          customClass: "notify-success-title",
        });
      });
    },
    handleSortChange(value) {
      // 考勤时间
      if (value.prop === "signedTimeStr") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.signedTime = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.signedTime = true;
          this.queryParam.orders.userName = null;
          this.queryParam.orders.onlineTime = null;
          this.queryParam.orders.gap = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.signedTime = false;
          this.queryParam.orders.userName = null;
          this.queryParam.orders.onlineTime = null;
          this.queryParam.orders.gap = null;
        }
      }
      // 人员姓名
      if (value.prop === "userName") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.userName = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.userName = true;
          this.queryParam.orders.signedTime = null;
          this.queryParam.orders.onlineTime = null;
          this.queryParam.orders.gap = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.userName = false;
          this.queryParam.orders.signedTime = null;
          this.queryParam.orders.onlineTime = null;
          this.queryParam.orders.gap = null;
        }
      }
      // 在岗时长
      if (value.prop === "onlineTime") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.onlineTime = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.onlineTime = true;
          this.queryParam.orders.userName = null;
          this.queryParam.orders.signedTime = null;
          this.queryParam.orders.gap = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.onlineTime = false;
          this.queryParam.orders.userName = null;
          this.queryParam.orders.signedTime = null;
          this.queryParam.orders.gap = null;
        }
      }
      // 考勤距离
      if (value.prop === "gapStr") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.gap = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.gap = true;
          this.queryParam.orders.userName = null;
          this.queryParam.orders.signedTime = null;
          this.queryParam.orders.onlineTime = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.gap = false;
          this.queryParam.orders.userName = null;
          this.queryParam.orders.signedTime = null;
          this.queryParam.orders.onlineTime = null;
        }
      }
      this.paging.index = 1;
      this.getList();
    },
    handleClickTag(title, content) {
      if (!title || !content) {
        return;
      }
      this.$refs.TipDialogRef.show({
        title: title,
        content: content,
      });
    },
    handleCurrentChange(val) {
      this.paging.index = val;
      this.getList();
    },
    handleReset() {
      this.queryParam.date = computedLastData(0);
      this.queryParam.type = "";
      this.queryParam.realName = "";
      this.queryParam.stations = [];
      this.queryParam.state = "";
      this.queryParam.storeName = "";
      this.queryParam.distance = "";
    },
    handleSearch() {
      this.paging.index = 1;
      this.getList();
    },
    initMap() {
      this.$nextTick(() => {
        if (!this.$refs.mapRef) {
          setTimeout(() => this.initMap(), 100);
          return;
        }

        this.map = new AMap.Map(this.$refs.mapRef, {
          zoom: 12,
          resizeEnable: true,
          mapStyle: "amap://styles/70f782dd9696b05f4063dfcf88a342b2",
          center: [116.397428, 39.90923],
        });

        this.map.on("click", () => {
          this.map.clearInfoWindow();
        });

        this.addMarkers();
      });
    },
    initIcon(item) {
      let image = "";
      let size = new AMap.Size(12, 15);
      let imageSize = new AMap.Size(12, 15);
      if (item.pointType === 2 && item.icon) {
        image = item.icon;
        size = new AMap.Size(30, 30);
        imageSize = new AMap.Size(30, 30);
      } else if (item.isRepaired) {
        image = require("@/assets/location/address-red.png");
      } else if (item.signedType === 0) {
        image = require("@/assets/location/address-green.png");
      } else {
        image = require("@/assets/location/address.png");
      }
      return new AMap.Icon({
        size: size,
        image: image,
        imageSize: imageSize,
      });
    },
    getMarkerOffset(item) {
      if (item.pointType === 2 && item.icon) {
        return new AMap.Pixel(-5, -60);
      }
      return new AMap.Pixel(-15, -60);
    },
    addMarkers() {
      if (!this.map || !this.mapData || this.mapData.length === 0) return;

      this.map.clearMap();

      const data = this.mapData;
      const markers = [];

      data.forEach((item) => {
        const lng = parseFloat(item.preciseLng);
        const lat = parseFloat(item.preciseLat);
        if (isNaN(lng) || isNaN(lat) || lng <= 0 || lat <= 0) return;

        const marker = new AMap.Marker({
          position: [lng, lat],
          icon: this.initIcon(item),
          title: item.address || "",
          offset: new AMap.Pixel(-20, -50),
        });

        marker.on("click", () => {
          this.focusMarker(marker, item);
        });

        markers.push(marker);
        this.map.add(marker);
      });

      if (markers.length > 0) {
        this.map.setFitView(markers);
      }
    },
    focusMarker(marker, item) {
      const position = marker.getPosition();
      this.showInfoWindow(position, item);
      const lng = position.getLng();
      const lat = position.getLat() + 0.0001;
      this.map.setZoomAndCenter(20, [lng, lat]);
    },
    showInfoWindow(position, item) {
      if (item.pointType === 1) {
        const title = item.signedType === 0 ? "到岗签到" : "离岗签退";
        const windowClass =
          item.signedType === 1 ? "map-info-window blue" : "map-info-window";

        let tagsHtml = "";
        if (item.states && item.states.length > 0) {
          item.states.forEach((tag, index) => {
            tagsHtml += `<span class="map-info-footer-tag ${
              tag === "较远"
                ? "yellow"
                : tag === "异常" || tag === "无效" || tag === "超出"
                ? "red"
                : ""
            }">${tag}</span>`;
          });
        }

        const infoWindow = new AMap.InfoWindow({
          isCustom: true,
          content: `
          <div class="${windowClass}">
            <div class="map-info-title">${title}</div>
            <div class="map-info-content">
              ${item.enterpriseName || ""}
            </div>
            <div class="map-info-content">
              ${item.signedTime || ""}
            </div>
            <div class="map-info-footer">
              <div class="map-info-footer-left">${item.userName || ""}</div>
              <div class="map-info-footer-right">
                ${tagsHtml}
              </div>
            </div>
          </div>
        `,
          offset: this.getMarkerOffset(item),
        });
        infoWindow.open(this.map, position);
      } else {
        let typesHtml = "";
        if (item.enterpriseTypes && item.enterpriseTypes.length > 0) {
          const typeClassMap = {
            药品生产: "ypsc",
            药品批发: "yppf",
            连锁总部: "lszb",
            连锁门店: "lsmd",
            医疗机构: "yljg",
            单体门店: "dtmd",
          };
          item.enterpriseTypes.forEach((v, i) => {
            const tagClass = typeClassMap[v] || "";
            typesHtml += `<div class="map-info-tag ${tagClass}">${v}</div>`;
          });
        }

        const infoWindow = new AMap.InfoWindow({
          isCustom: true,
          content: `
          <div class="map-info-window white">
            <div class="map-info-title">${item.enterpriseName || ""}</div>
            <div class="map-info-tag-box">
              ${typesHtml}
            </div>
            <div class="map-info-content">
              ${item.enterpriseLocation || ""}
            </div>
          </div>
        `,
          offset: this.getMarkerOffset(item),
        });
        infoWindow.open(this.map, position);
      }
    },
    async getList() {
      this.loading = true;
      const { data, extended } =
        await this.$api.enterprise.GetMyStoreCheckWorkList({
          ...this.queryParam,
          paging: this.paging,
        });
      this.tableList = data.list;
      this.total = extended.paging.total;
      this.mapData = data.map || [];

      if (this.mapData.length === 0 && this.map) {
        this.map.clearMap();
        this.map.setCenter([116.397428, 39.90923]);
        this.map.setZoom(12);
      }
      this.addMarkers();
      this.loading = false;
    },
    async fetchData() {
      this.queryParam.date = computedLastData(0);
      this.loading = true;
      const { data: filtersData } =
        await this.$api.enterprise.GetMyStoreCheckWorkFilters();
      this.filterData = filtersData;
      const { data, extended } =
        await this.$api.enterprise.GetMyStoreCheckWorkList({
          ...this.queryParam,
          paging: this.paging,
        });
      this.tableList = data.list;
      this.total = extended.paging.total;
      this.mapData = data.map || [];

      if (this.mapData.length === 0 && this.map) {
        this.map.clearMap();
        this.map.setCenter([116.397428, 39.90923]);
        this.map.setZoom(12);
      }
      this.addMarkers();
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
